<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">eAssist Oral Surgery Assessment Test</h1>
                        <p style="margin: 10px 0">Instructions:</p>
                        <div class="mt10 fs14 lh25">Please read each question carefully. Choose the correct answer(s) to each question. Disclaimer: Some
                            questions have more than one correct answer
                        </div>
                        <p class="required" style="margin: 10px 0">* Required</p>
                    </div>

                    <el-form :model="form" :inline="false" :rules="rules" ref="form">
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=1" :src="wrong"></el-image>
                                1)If Dental Insurance covers all procedures, can you bill Medical Insurance as secondary for any remaining balance?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item ref="sub0" prop="sub0" class="mt20">
                                <el-radio-group ref="sub0" v-model="form.sub0" :disabled="isAdmin">
                                    <el-radio :label="0">Yes, if the procedure is medically necessary</el-radio><br>
                                    <el-radio :label="1">Yes, if coordination of benefits permits and the medical insurance has coverage for those procedures </el-radio>
                                    <el-image v-if="isAdmin&&form.sub0!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">No, medical insurance typically won’t cover the remaining balance</el-radio><br>
                                    <el-radio :label="3">Only if there is a remaining deductible on the medical plan</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=0" :src="wrong"></el-image>
                                2) Can Dental Insurance be billed if Medical Insurance applied the treatment to the patient’s deductible?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub1">
                                <el-radio-group ref="sub1" v-model="form.sub1" :disabled="isAdmin">
                                    <el-radio :label="0">Yes, if dental coverage allows for it</el-radio>
                                    <el-image v-if="isAdmin&&form.sub1!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No, the patient is responsible for the deductible</el-radio><br>
                                    <el-radio :label="2">Yes, but only for the amount exceeding the deductible</el-radio><br>
                                    <el-radio :label="3">No, Dental Insurance won't cover anything applied to a medical deductible</el-radio><br>

                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=3" :src="wrong"></el-image>
                                3) If Medical Insurance applied treatment to the patient’s deductible and Dental Insurance has been billed with no payment issued, what could be the reason for the denial?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub2">
                                <el-radio-group ref="sub2" v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">Coordination of benefits was not properly managed</el-radio><br>
                                    <el-radio :label="1">The claim was not submitted correctly</el-radio><br>
                                    <el-radio :label="2">The dental plan doesn't cover the specific procedures</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub2!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=0" :src="wrong"></el-image>
                                4) When submitting a claim to Blue Cross Blue Shield (BCBS) medical, where should the claim be sent?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub3" class="mt20">
                                <el-radio-group ref="sub3" v-model="form.sub3" :disabled="isAdmin">
                                    <el-radio :label="0">To the local BCBS office</el-radio>
                                    <el-image v-if="isAdmin&&form.sub3!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Directly to the patient’s employer</el-radio><br>
                                    <el-radio :label="2">To a central processing center specified by BCBS</el-radio><br>
                                    <el-radio :label="3">To the patient's dental insurance company</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=0" :src="wrong"></el-image>
                                5) What form is used to bill Medical Insurance?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub4">
                                <el-radio-group ref="sub4" v-model="form.sub4" :disabled="isAdmin">
                                    <el-radio :label="0">CMS 1500</el-radio>
                                    <el-image v-if="isAdmin&&form.sub4!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">ADA</el-radio><br>
                                    <el-radio :label="2">ICD-10</el-radio><br>
                                    <el-radio :label="3">UB04</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=0" :src="wrong"></el-image>
                                6) Where can you find the correct address to send information when appealing a claim?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub5">
                                <el-radio-group ref="sub5" v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">On the EOB</el-radio>
                                    <el-image v-if="isAdmin&&form.sub5!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">On the insurance card</el-radio><br>
                                    <el-radio :label="2">On the fee schedule</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=0" :src="wrong"></el-image>
                                7) What is the purpose of Coordination of Benefits (COB)?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub6">
                                <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">To ensure that benefits are not duplicated</el-radio>
                                    <el-image v-if="isAdmin&&form.sub6!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">To allow the patient to choose which insurance pays first</el-radio><br>
                                    <el-radio :label="2">To split the cost evenly between insurance companies</el-radio><br>
                                    <el-radio :label="3">To get a patient a refund</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=0" :src="wrong"></el-image>
                                8) If Medical Insurance denies a claim and Dental Insurance is secondary, what should you do next?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub7">
                                <el-radio-group ref="sub7" v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">Submit the claim to Dental Insurance with the denial</el-radio>
                                    <el-image v-if="isAdmin&&form.sub7!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Appeal the Medical Insurance decision</el-radio><br>
                                    <el-radio :label="2">Bill the patient directly</el-radio><br>
                                    <el-radio :label="3">Resubmit the claim with a different diagnosis code</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=3" :src="wrong"></el-image>
                                9) What information should be included when appealing a denied claim?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub8">
                                <el-radio-group ref="sub8" v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">Original claim and EOB</el-radio><br>
                                    <el-radio :label="1">Supporting documentation (e.g., radiographs, clinical notes)</el-radio><br>
                                    <el-radio :label="2">A clear and concise appeal letter</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub8!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=3" :src="wrong"></el-image>
                                10) If a patient is treated by an out-of-network provider, how might their benefits differ from in-network care?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub9" ref="sub9">
                                <el-radio-group ref="sub9" v-model="form.sub9" :disabled="isAdmin">
                                    <el-radio :label="0">Higher out-of-pocket costs for the patient</el-radio><br>
                                    <el-radio :label="1">Lower reimbursement rates for the provider</el-radio><br>
                                    <el-radio :label="2">No coverage for certain procedures</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub9!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=1" :src="wrong"></el-image>
                                11) How would you handle a situation where the secondary insurance denies payment because the primary insurance paid more than expected?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub10">
                                <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">Submit an appeal to the secondary insurance</el-radio><br>
                                    <el-radio :label="1">Adjust the claim according to the primary insurance’s payment</el-radio>
                                    <el-image v-if="isAdmin&&form.sub10!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Bill the patient for the remaining balance</el-radio><br>
                                    <el-radio :label="3">None of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=3" :src="wrong"></el-image>
                                12) When is it appropriate to bill Medical Insurance for a 3rd molar extraction?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub11">
                                <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0">If the removal is required due to an underlying medical condition</el-radio><br>
                                    <el-radio :label="1">If the Medical Insurance the primary according to Coordination of Benefit COB</el-radio><br>
                                    <el-radio :label="2">If the procedure is for completely bony impacted teeth</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub11!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=1" :src="wrong"></el-image>
                                13) What procedure and diagnosis codes can be used when submitting a medical claim for the removal of 3rd molars?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub12">
                                <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">D7240 and 41899</el-radio><br>
                                    <el-radio :label="1">D7240 and 41899 with diagnosis K01.1</el-radio>
                                    <el-image v-if="isAdmin&&form.sub12!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">D7210 and 41120 with diagnosis of K01.1</el-radio><br>
                                    <el-radio :label="3">D7230 and 41899</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=1" :src="wrong"></el-image>
                                14) Should Oral Surgeons bill all extractions using code D7210 or higher because they are specialists?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub13">
                                <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">YES</el-radio><br>
                                    <el-radio :label="1">NO</el-radio>
                                    <el-image v-if="isAdmin&&form.sub13!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=0" :src="wrong"></el-image>
                                15) What documentation should be sent to support the billing of D7241?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub14">
                                <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">Radiographs and clinical notes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub14!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Pathology report</el-radio><br>
                                    <el-radio :label="2">Pre-authorization approval</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=3" :src="wrong"></el-image>
                                16) What action can the insurance company take if proper documents are not included with the billing of D7210-D7241?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub15">
                                <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">Deny the claim</el-radio><br>
                                    <el-radio :label="1">Request additional information</el-radio><br>
                                    <el-radio :label="2">Pay a reduced amount</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub15!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=1" :src="wrong"></el-image>
                                17) An EOB downgrades tooth #1 from D7240 to D7230. What is your next step?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub16">
                                <el-radio-group ref="sub16" v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">Post the payment</el-radio><br>
                                    <el-radio :label="1">Appeal the decision with additional documentation</el-radio>
                                    <el-image v-if="isAdmin&&form.sub16!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Contact the patient for the balance</el-radio><br>
                                    <el-radio :label="3">Resubmit the claim without changes</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=1" :src="wrong"></el-image>
                                18) When billing for a dental implant, which medical condition might justify coverage under medical insurance?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub17">
                                <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">Aesthetic reasons</el-radio><br>
                                    <el-radio :label="1">Loss of tooth from an accident</el-radio>
                                    <el-image v-if="isAdmin&&form.sub17!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Patient preference</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=0" :src="wrong"></el-image>
                                19) An EOB denied D9223, stating "criteria for benefits not met," but the insurance verification shows D9223 covered at 80%. What is your next step?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub18">
                                <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                    <el-radio :label="0">Appeal the decision with supporting documentation</el-radio>
                                    <el-image v-if="isAdmin&&form.sub18!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Resubmit the claim as is</el-radio><br>
                                    <el-radio :label="2">Contact the patient to pay out-of-pocket</el-radio><br>
                                    <el-radio :label="3">Adjust the claim to reflect a different code</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=0" :src="wrong"></el-image>
                                20) If the office has verified that D9223 (IV sedation) is a covered benefit, will the patient be covered for D9223 and D7210 (extraction)?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub19">
                                <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">Yes, if both procedures are medically necessary</el-radio>
                                    <el-image v-if="isAdmin&&form.sub19!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No, only one procedure will be covered</el-radio><br>
                                    <el-radio :label="2">Yes, but only if billed on separate dates</el-radio><br>
                                    <el-radio :label="3">No, as they are considered duplicate services</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=1" :src="wrong"></el-image>
                                21) Which CPT code is commonly used for bone grafting associated with dental implants?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub20">
                                <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                    <el-radio :label="0">20931</el-radio><br>
                                    <el-radio :label="1">21210</el-radio>
                                    <el-image v-if="isAdmin&&form.sub20!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">21248</el-radio><br>
                                    <el-radio :label="3">20962</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=1" :src="wrong"></el-image>
                                22) Where can you usually find the diagnosis code for a biopsy?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub21">
                                <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                    <el-radio :label="0">Patient’s medical history</el-radio><br>
                                    <el-radio :label="1">Pathology report</el-radio>
                                    <el-image v-if="isAdmin&&form.sub21!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Preoperative notes</el-radio><br>
                                    <el-radio :label="3">X-ray reports</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=1" :src="wrong"></el-image>
                                23) At what point in the process should you submit a claim for a biopsy?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub22">
                                <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                    <el-radio :label="0">Before the biopsy is performed</el-radio><br>
                                    <el-radio :label="1">After receiving the pathology report</el-radio>
                                    <el-image v-if="isAdmin&&form.sub22!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">At the same time as the surgery claim</el-radio><br>
                                    <el-radio :label="3">Only if the biopsy shows positive results</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=0" :src="wrong"></el-image>
                                24) What documentation should be sent to support the billing of D7286?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub23">
                                <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                    <el-radio :label="0">Pathology report and clinical notes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub23!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Radiographs</el-radio><br>
                                    <el-radio :label="2">Patient consent form</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=3" :src="wrong"></el-image>
                                25) What conditions may constitute a Medical Necessity for Anesthesia benefits, including IV sedation?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub24">
                                <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                    <el-radio :label="0">Severe anxiety or phobia </el-radio><br>
                                    <el-radio :label="1">Young age or inability to cooperate</el-radio><br>
                                    <el-radio :label="2">Significant medical conditions (e.g., cardiac issues)</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub24!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub25!=0" :src="wrong"></el-image>
                                26) A patient with a history of periodontal disease is receiving implants. What documentation should be included with the claim to ensure coverage?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub25">
                                <el-radio-group ref="sub25" v-model="form.sub25" :disabled="isAdmin">
                                    <el-radio :label="0">Periodontal charting and clinical notes with medical necessity</el-radio>
                                    <el-image v-if="isAdmin&&form.sub25!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Only the X-rays and implant placement notes</el-radio><br>
                                    <el-radio :label="2">A letter of medical necessity from the referring dentist</el-radio><br>
                                    <el-radio :label="3">No additional documentation is needed beyond standard submission</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub26!=0" :src="wrong"></el-image>
                                27) During an extraction, a tooth fractures, and a surgical extraction is necessary. How should the extraction be billed?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub26">
                                <el-radio-group ref="sub26" v-model="form.sub26" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the surgical extraction only</el-radio>
                                    <el-image v-if="isAdmin&&form.sub26!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Bill the simple extraction and surgical extraction separately</el-radio><br>
                                    <el-radio :label="2">Combine both procedures under the surgical extraction code</el-radio><br>
                                    <el-radio :label="3">Bill the simple extraction with a modifier for complications</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub27!=0" :src="wrong"></el-image>
                                28) An oral surgeon performs a surgical extraction on a tooth that was previously attempted by a general dentist but was unsuccessful. How should this be billed?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub27">
                                <el-radio-group ref="sub27" v-model="form.sub27" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the extraction as a new procedure </el-radio>
                                    <el-image v-if="isAdmin&&form.sub27!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Use a modified code to indicate the previous attempt</el-radio><br>
                                    <el-radio :label="2">Bill the procedure as a consult with a minor surgical procedure</el-radio><br>
                                    <el-radio :label="3">Combine the extraction with the previous attempt in one code</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub28!=1" :src="wrong"></el-image>
                                29) How should you bill for the removal of residual roots after a previous extraction attempt?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub28">
                                <el-radio-group ref="sub28" v-model="form.sub28" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the procedure as a new extraction </el-radio><br>
                                    <el-radio :label="1">Use a code specifically for removal of residual roots</el-radio>
                                    <el-image v-if="isAdmin&&form.sub28!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Combine the residual root removal with the previous extraction code</el-radio><br>
                                    <el-radio :label="3">Bill only for the follow-up visit</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest">
                                <el-image v-if="isAdmin&&form.sub29!=0" :src="wrong"></el-image>
                                30) If a patient’s insurance denies IV sedation coverage, stating that it was not medically necessary, what should your next step be?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub29" class="mt10">
                                <el-radio-group ref="sub29" v-model="form.sub29" :disabled="isAdmin">
                                    <el-radio :label="0">Appeal the decision with additional documentation</el-radio>
                                    <el-image v-if="isAdmin&&form.sub29!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Resubmit the claim without changes</el-radio><br>
                                    <el-radio :label="2">Bill the patient directly for the sedation</el-radio><br>
                                    <el-radio :label="3">Adjust the claim to reflect a different sedation method</el-radio>
                                </el-radio-group>
                            </el-form-item>

                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub30!=2" :src="wrong"></el-image>
                                31) If an unrelated procedure is done on the same day as an exam, what modifier is required if billing Medical Insurance?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub30">
                                <el-radio-group ref="sub30" v-model="form.sub30" :disabled="isAdmin">
                                    <el-radio :label="0">52</el-radio><br>
                                    <el-radio :label="1">50</el-radio><br>
                                    <el-radio :label="2">25</el-radio>
                                    <el-image v-if="isAdmin&&form.sub30!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">None</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub31!=0" :src="wrong"></el-image>
                                32) An assistant surgeon is required during a complex oral surgery case. How should the services of the assistant surgeon be billed?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub31">
                                <el-radio-group ref="sub31" v-model="form.sub31" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the assistant surgeon’s services on the same claim with modifier</el-radio>
                                    <el-image v-if="isAdmin&&form.sub31!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Include the assistant surgeon’s fee in the primary surgeon’s billing</el-radio><br>
                                    <el-radio :label="2">Use a modifier to indicate the involvement of an assistant surgeon</el-radio><br>
                                    <el-radio :label="3">Bill only the primary surgeon’s services, as the assistant is considered part of the team</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub32!=0" :src="wrong"></el-image>
                                33) A patient returns for a post-operative follow-up two weeks after surgery. How should this visit be billed?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub32">
                                <el-radio-group ref="sub32" v-model="form.sub32" :disabled="isAdmin">
                                    <el-radio :label="0">Bill it under the global surgical fee guidlines</el-radio>
                                    <el-image v-if="isAdmin&&form.sub32!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Use a post-operative follow-up code</el-radio><br>
                                    <el-radio :label="2">Include the visit in the original surgery code</el-radio><br>
                                    <el-radio :label="3">Bill the patient directly for the follow-up</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub33!=3" :src="wrong"></el-image>
                                34) A patient with a history of heart disease requires oral surgery. What documentation should be provided to establish the medical necessity of the procedure?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub33">
                                <el-radio-group ref="sub33" v-model="form.sub33" :disabled="isAdmin">
                                    <el-radio :label="0">A letter of medical necessity from the patient’s cardiologist</el-radio><br>
                                    <el-radio :label="1">Detailed clinical notes from the oral surgeon explaining the need for surgery</el-radio><br>
                                    <el-radio :label="2">Copies of the patient’s relevant medical records</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub33!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub34!=3" :src="wrong"></el-image>
                                35) A claim for an implant procedure is denied because the insurance company states there is insufficient evidence of bone loss. What documentation should be provided to support the claim?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub34">
                                <el-radio-group ref="sub34" v-model="form.sub34" :disabled="isAdmin">
                                    <el-radio :label="0">Radiographs showing the extent of bone loss</el-radio><br>
                                    <el-radio :label="1">A letter from the oral surgeon describing the clinical findings</el-radio><br>
                                    <el-radio :label="2">CBCT images if available</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub34!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub35!=0" :src="wrong"></el-image>
                                36) During a surgical extraction, additional time was required due to complications. Which modifier should be used to indicate the increased complexity?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub35">
                                <el-radio-group ref="sub35" v-model="form.sub35" :disabled="isAdmin">
                                    <el-radio :label="0">Modifier 22 (Increased Procedural Services)</el-radio>
                                    <el-image v-if="isAdmin&&form.sub35!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Modifier 52 (Reduced Services)</el-radio><br>
                                    <el-radio :label="2">Modifier 59 (Distinct Procedural Service)</el-radio><br>
                                    <el-radio :label="3">Modifier 78 (Unplanned Return to Operating Room)</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub36!=1" :src="wrong"></el-image>
                                37) If a patient requires the same procedure on multiple teeth during the same visit, what modifier should be applied?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub36">
                                <el-radio-group ref="sub36" v-model="form.sub36" :disabled="isAdmin">
                                    <el-radio :label="0">Modifier 50 (Bilateral Procedure)</el-radio><br>
                                    <el-radio :label="1">Modifier 51 (Multiple Procedures)</el-radio>
                                    <el-image v-if="isAdmin&&form.sub36!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Modifier 59 (Distinct Procedural Service)</el-radio><br>
                                    <el-radio :label="3">Modifier 62 (Two Surgeons)</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub37!=0" :src="wrong"></el-image>
                                38) How should you bill for a CBCT scan (70486) taken as part of surgical planning for a dental implant?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub37">
                                <el-radio-group ref="sub37" v-model="form.sub37" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the CBCT scan separately from the implant placement</el-radio>
                                    <el-image v-if="isAdmin&&form.sub37!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Include the scan in the surgical planning fee</el-radio><br>
                                    <el-radio :label="2">Use a combined code for the CBCT scan and implant placement</el-radio><br>
                                    <el-radio :label="3">Bill the CBCT scan as part of the pre-operative evaluation</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub38!=0" :src="wrong"></el-image>
                                39) If a claim is denied for incorrect coding, what is the appropriate course of action?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub38">
                                <el-radio-group ref="sub38" v-model="form.sub38" :disabled="isAdmin">
                                    <el-radio :label="0">Correct the coding error and resubmit the claim</el-radio>
                                    <el-image v-if="isAdmin&&form.sub38!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Appeal the decision without changing the code</el-radio><br>
                                    <el-radio :label="2">Contact the patient for payment</el-radio><br>
                                    <el-radio :label="3">Cancel the claim and write off the procedure</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub39!=2" :src="wrong"></el-image>
                                40) How do you determine which insurance is primary when a patient has dual coverage through their employer and a spouse’s employer?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub39">
                                <el-radio-group ref="sub39" v-model="form.sub39" :disabled="isAdmin">
                                    <el-radio :label="0">The insurance from the employer with the earlier birthdate in the year is primary</el-radio><br>
                                    <el-radio :label="1">The patient can choose which insurance to use as primary</el-radio><br>
                                    <el-radio :label="2">The insurance from the patient’s employer is always primary</el-radio>
                                    <el-image v-if="isAdmin&&form.sub39!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">The insurance with the lower deductible is primary</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box" >
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub40!=2" :src="wrong"></el-image>
                                41) What is the process for handling a claim when the primary insurance denies a procedure, but the secondary insurance covers it?
                                <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub40">
                                <el-radio-group ref="sub40" v-model="form.sub40" :disabled="isAdmin">
                                    <el-radio :label="0">Bill the patient directly for the denied procedure</el-radio><br>
                                    <el-radio :label="1">Adjust the claim based on the denial and resubmit to the secondary insurance</el-radio><br>
                                    <el-radio :label="2">Submit the denial from the primary insurance along with the claim to the secondary insurance</el-radio>
                                    <el-image v-if="isAdmin&&form.sub40!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">Submit the claim to the secondary insurance without mentioning the denial</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="btnLayout">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                            <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
                        </div>
                    </el-form>
                </div>

                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">eAssist Oral Surgery Assessment Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                    <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                    <span>Thank you for completing this knowledge assessment!</span><br/>
                    <span>Please allow up to three business days while we review your application.</span>
                    <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "oralSurgeryTest",
        components:{ApplyHeader,Side},
        data(){
            return{
                finishDate:'',
                loading:false,
                wrong:wrong,
                right:right,
                exitVisible:false,
                confirmVisible:false,
                showResult:false,
                hasFinished:false,
                smallScreen:false,
                correctNum:0,
                totalNum:41,
                completionDialogVisible: false,
                form:{
                    sub0:'',
                    sub1:'',
                    sub2:'',
                    sub3:'',
                    sub4:'',
                    sub5:'',
                    sub6:'',
                    sub7:'',
                    sub8:'',
                    sub9:'',
                    sub10:'',
                    sub11:'',
                    sub12:'',
                    sub13:'',
                    sub14:'',
                    sub15:'',
                    sub16:'',
                    sub17:'',
                    sub18:'',
                    sub19:'',
                    sub20:'',
                    sub21:'',
                    sub22:'',
                    sub23:'',
                    sub24:'',
                    sub25:'',
                    sub26:'',
                    sub27:'',
                    sub28:'',
                    sub29:'',
                    sub30:'',
                    sub31:'',
                    sub32:'',
                    sub33:'',
                    sub34:'',
                    sub35:'',
                    sub36:'',
                    sub37:'',
                    sub38:'',
                    sub39:'',
                    sub40:'',
                },
                isAdmin:false,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
                rules: {
                    sub0: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub1: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub2: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub3: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub4: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub5: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub6: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub7: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub8: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub9: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub10: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub11: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub12: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub13: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub14: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub15: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub16: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub17: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub18: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub19: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub20: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub21: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub22: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub23: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub24: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub25: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub26: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub27: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub28: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub29: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub30: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub31: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub32: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub33: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub34: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub35: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub36: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub37: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub38: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub39: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub40: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ]
                },
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                let per = Number(100*this.correctNum/this.totalNum).toFixed(2)
                return per+'%'
            },
            correctBalance(){
                return function (form,num) {
                    return this.coverBalance(form,num)&&this.coverBalance(form,num+'.00')
                        &&this.coverBalance(form,'$'+num)&&this.coverBalance(form,'$'+num+'.00')
                }

            },
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            getUserAnswerData(id,email){
                // console.log('id',id);
                // console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        // console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data&&res.data.detail!=null){
                            this.finishDate = res.data.finishDate||''
                            var list = res.data.detail
                            for(var i=0;i<list.length;i++){
                                this.$set(this.form,('sub'+i),list[i])
                            }
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                // console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            coverBalance(subStr,str){
                var reg = eval("/"+subStr+"/ig");
                return reg.test(str);
            },
            calScore(){//算正确分数 总分80
                var score=0
                this.correctNum=0
                if(this.form.sub0==1) {score += 1;this.correctNum++}
                if(this.form.sub1==0) {score += 1;this.correctNum++}
                if(this.form.sub2==3) {score += 1;this.correctNum++}
                if(this.form.sub3==0) {score += 1;this.correctNum++}
                if(this.form.sub4==0) {score += 1;this.correctNum++}
                if(this.form.sub5==0) {score += 1;this.correctNum++}
                if(this.form.sub6==0) {score += 1;this.correctNum++}
                if(this.form.sub7==0) {score += 1;this.correctNum++}
                if(this.form.sub8==3) {score += 1;this.correctNum++}
                if(this.form.sub9==3) {score += 1;this.correctNum++}
                if(this.form.sub10==1) {score += 1;this.correctNum++}
                if(this.form.sub11==3) {score += 1;this.correctNum++}
                if(this.form.sub12==1) {score += 1;this.correctNum++}
                if(this.form.sub13==1) {score += 1;this.correctNum++}
                if(this.form.sub14==0) {score += 1;this.correctNum++}
                if(this.form.sub15==3) {score += 1;this.correctNum++}
                if(this.form.sub16==1) {score += 1;this.correctNum++}
                if(this.form.sub17==1) {score += 1;this.correctNum++}
                if(this.form.sub18==0) {score += 1;this.correctNum++}
                if(this.form.sub19==0) {score += 1;this.correctNum++}
                if(this.form.sub20==1) {score += 1;this.correctNum++}
                if(this.form.sub21==1) {score += 1;this.correctNum++}
                if(this.form.sub22==1) {score += 1;this.correctNum++}
                if(this.form.sub23==0) {score += 1;this.correctNum++}
                if(this.form.sub24==3) {score += 1;this.correctNum++}
                if(this.form.sub25==0) {score += 1;this.correctNum++}
                if(this.form.sub26==0) {score += 1;this.correctNum++}
                if(this.form.sub27==0) {score += 1;this.correctNum++}
                if(this.form.sub28==1) {score += 1;this.correctNum++}
                if(this.form.sub29==0) {score += 1;this.correctNum++}
                if(this.form.sub30==2) {score += 1;this.correctNum++}
                if(this.form.sub31==0) {score += 1;this.correctNum++}
                if(this.form.sub32==0) {score += 1;this.correctNum++}
                if(this.form.sub33==3) {score += 1;this.correctNum++}
                if(this.form.sub34==3) {score += 1;this.correctNum++}
                if(this.form.sub35==0) {score += 1;this.correctNum++}
                if(this.form.sub36==1) {score += 1;this.correctNum++}
                if(this.form.sub37==0) {score += 1;this.correctNum++}
                if(this.form.sub38==0) {score += 1;this.correctNum++}
                if(this.form.sub39==2) {score += 1;this.correctNum++}
                if(this.form.sub40==2) {score += 1;this.correctNum++}
                return score
            },
            goPre(){
                this.$router.go(-1)
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                this.confirmVisible=false
                var score=0
                var list=[]
                var len = Object.keys(this.form).length
                for(var i=0;i<len;i++){
                    list.push(this.form['sub'+i])
                }
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 41
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                // return
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.completionDialogVisible = true
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            // console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            // console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
        },
        mounted() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            this.getData()
        },
        watch:{
            '$route'(to,from){
                // console.log(from.path)
                if(to.path==='/oralSurgeryTest1'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .rightPic{
        width: 20px;
        position: absolute;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .radioText{
        display: inline-block;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>